/** Display helpers only — backend is the source of truth for all money amounts. */

/** Flat delivery charge per quantity unit (₹). Kept for labels; prefer API delivery_amount. */
export const DELIVERY_PER_QTY = 25;
/** @deprecated use DELIVERY_PER_QTY */
export const RAW_MATERIAL_DELIVERY_PER_QTY = DELIVERY_PER_QTY;

/** Prefer backend `delivery_amount`. */
export function cartLineDelivery(item: {
  delivery_amount?: number | null;
  quantity?: number | null;
}): number {
  if (typeof item.delivery_amount === "number" && Number.isFinite(item.delivery_amount)) {
    return item.delivery_amount;
  }
  const qty = Number(item.quantity ?? 0) || 0;
  return Math.round(qty * DELIVERY_PER_QTY * 100) / 100;
}

/** Prefer backend `packaging_amount`. */
export function cartLinePackaging(item: {
  packaging_amount?: number | null;
}): number {
  if (typeof item.packaging_amount === "number" && Number.isFinite(item.packaging_amount)) {
    return item.packaging_amount;
  }
  return 0;
}

/** Prefer backend `gst_amount`. */
export function cartLineGst(item: {
  gst_amount?: number | null;
}): number {
  if (typeof item.gst_amount === "number" && Number.isFinite(item.gst_amount)) {
    return item.gst_amount;
  }
  return 0;
}

/**
 * Prefer backend `total_price` (already includes GST for products; RM line total for raw materials).
 * Does not recompute sqft/margins on the client.
 */
export function cartLineProductTotal(item: {
  total_price?: number | null;
  base_amount?: number | null;
}): number {
  if (typeof item.total_price === "number" && Number.isFinite(item.total_price)) {
    return item.total_price;
  }
  if (typeof item.base_amount === "number" && Number.isFinite(item.base_amount)) {
    return item.base_amount;
  }
  return 0;
}
